var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"解锁卡片","width":"400","closable":false},on:{"on-ok":_vm.conformOk,"on-cancel":_vm.cancel},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('p',[_vm._v("\n    确定要解除此人的会员卡锁定吗？")])])
}
var staticRenderFns = []

export { render, staticRenderFns }